/** @format */

import React from "react";
import { ResourceReference } from "../../types";
import { Link, useParams } from "react-router-dom";
import { Markup } from "interweave";
import { useTranslation } from "react-i18next";

type Props = {
  resource?: ResourceReference;
};

const BreadCrumb: React.FC<Props> = ({ resource }) => {
  const { t: _ } = useTranslation();
  const { subject: subjectTitle } = useParams();

  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb mb-0 mb-sm-2">
        <li className="breadcrumb-item" aria-current="page">
          <Link to={`${resource ? "../../" : "../"}`} className="text-reset">
            {_("Subjects")}
          </Link>
        </li>
        {resource ? (
          <>
            <li className="breadcrumb-item" aria-current="page">
              <Link to="../" className="text-reset">
                {subjectTitle}
              </Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              <Markup content={resource.Object.title} />
            </li>
          </>
        ) : (
          <>
            <li className="breadcrumb-item active" aria-current="page">
              {subjectTitle}
            </li>
          </>
        )}
      </ol>
    </nav>
  );
};

export default BreadCrumb;
